var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterrogation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8.8 12.8C8.8 13.2418 8.44183 13.6 8 13.6C7.55817 13.6 7.2 13.2418 7.2 12.8C7.2 12.3582 7.55817 12 8 12C8.44183 12 8.8 12.3582 8.8 12.8ZM10.456 7.4L9.736 8.136C9.336 8.544 9.048 8.912 8.904 9.488C8.87205 9.6158 8.84608 9.9011 8.82808 10.2006C8.80158 10.6416 8.44183 11 8 11C7.55817 11 7.2 10.6418 7.2 10.2V10C7.2 9.632 7.264 9.28 7.376 8.952C7.536 8.488 7.8 8.072 8.136 7.736L9.128 6.728C9.496 6.376 9.672 5.848 9.568 5.288C9.464 4.712 9.016 4.224 8.456 4.064C7.568 3.816 6.744 4.32 6.48 5.08C6.384 5.376 6.136 5.6 5.824 5.6H5.584C5.12 5.6 4.8 5.152 4.928 4.704C5.272 3.528 6.272 2.632 7.512 2.44C8.728 2.248 9.888 2.88 10.608 3.88C11.552 5.184 11.272 6.584 10.456 7.4Z",
    fill: "#550087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrogation);
export default __webpack_public_path__ + "static/media/interrogation.16f5f5fc92d06e1cb82eb4a42747712c.svg";
export { ForwardRef as ReactComponent };